import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

import { AlertService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'login-otp',
    templateUrl: './loginotp.component.html',
})

export class LoginotpComponent implements OnInit {

    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    mobileFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[0-9]{10}"),
    ]);
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userinfo: any;
    studentid: number = 0;    
    examid: number = 0;    

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { }


    ngOnInit() {
        /* clear loaclStorege */
        localStorage.clear();
        sessionStorage.clear();

        // reset login status
        //this.authenticationService.logout();
        this.spinner.hide();        
        this.returnUrl = '/';
    }

/*    ngAfterViewInit() {
        this.detectBrowserSuport();
    }*/
    onSubmit()
    {
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.mobileFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else
        {
            this.loading = true;
            this.spinner.show();
            this.authenticationService.loginwithotp(this.globals.root_url, this.mobileFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;
                            //var id = data.id_student;
                            this.loading = false;
                            this.spinner.hide();
                            this.router.navigateByUrl('/checkotp/'+ data.id_self_student +'/4');
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = data.status;
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid Mobile Number !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }
    onSubmit1() {
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.mobileFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            this.authenticationService.loginwithotp(this.globals.root_url, this.mobileFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.http.get("https://ipapi.co/json/").subscribe((res: any) => {
                                //this.http.get("//ip-api.com/json").subscribe((res:any)=>{ // for local testing
                                var geoipresponse = res;
                                if (geoipresponse != undefined) {
                                    localStorage.setItem('supspw_geoIPStu_pc', JSON.stringify(res));
                                }
                            });
                            this.globals.isExamOver = false;
                            this.isErrorLogin = false;
                            var settings = data.settings;
                            let usersettings = data.usersettings;
                            localStorage.setItem('currentUser_ps', JSON.stringify({ usercode: data.usercode, userid: data.user_id, subuserid: data.sub_user_id, name: data.name, code: this.mobileFormControl.value, id: data.std_id, examstatus: data.isvivaDone }));
                            if (typeof settings != undefined || typeof settings != 'undefined') {
                                sessionStorage.setItem('pkshn_exam_set_pc', JSON.stringify(settings));
                            }
                            if (typeof usersettings != undefined || typeof usersettings != 'undefined') {
                                 var userSetting = data.usersettings;
                                 sessionStorage.setItem('pkshn_user_settings_c_s',JSON.stringify(usersettings)); 
                            } 
                            var th, vi, pra, des, lstream;     
                            userSetting.forEach(function (value) { 
                                if(value.module == 'Theory'){th = value.status;}
                                if(value.module == 'Viva'){ vi = value.status;}
                                if(value.module == 'Descriptive'){ des = value.status;}
                                if(value.module == 'Practical'){ pra = value.status;}
                                if(value.module == 'Live Streaming'){ lstream = value.status;}        
                            });                                                  
                            var practical_id = data.practical_id;
                            if ((data.isvivaDone == 1 || data.isvivaDone == 3) && settings.descriptive == 1 && data.descriptive == 0 && des == 1) {
                                this.router.navigateByUrl('/descriptive');

                            }else  if (typeof practical_id != 'undefined' && pra == 1) {
                                let sett = { 'examid': data.exam_id, 'practicalid': data.practical_id, 'exam_logo': data.exam_logo, 'id_assessor': data.id_assessor, 'id_prac_video': data.id_prac_video, 'std_id': data.std_id };
                                sessionStorage.setItem('pkshn_vc_set_pc', JSON.stringify(sett));
                                var qstring = data.usercode + '//@spwd++sup@//' + data.exam_id + '//@spwd++sup@//' + data.practical_id + '//@spwd++sup@//' + data.std_id;
                                var parms = window.btoa(qstring);
                                this.router.navigateByUrl('/practical-welcome/' + parms);
                            }
                            else if (settings.otp == 1 && th == 1) {
                                //var parms = this.globals.getRandUrl('otp');
                                var qstring = data.usercode + '//@spwd++sup@//' + data.user_id + '//@spwd++sup@//' + data.sub_user_id + '//@spwd++sup@//' + data.std_id;
                                var parms = window.btoa(qstring);
                                this.router.navigateByUrl('/otp/' + parms);
                                //this.router.navigate(['otp'], { queryParams: { page: 1 } });
                            }
                            else {
                                
                                if(th == 1 && data.isvivaDone == 0 && settings.module == 3)
                                {
                                    var parms = this.globals.getRandUrl('verify');
                                    this.router.navigateByUrl('/verify/' + parms);
                                }else if(th == 1 && data.isvivaDone == 2 && settings.module == 3)
                                {
                                    var parms = this.globals.getRandUrl('verify');
                                    this.router.navigateByUrl('/verify/' + parms);
                                }else if(th == 1 && data.isvivaDone == 0 && settings.module == 1)
                                {
                                    var parms = this.globals.getRandUrl('verify');
                                    this.router.navigateByUrl('/verify/' + parms);
                                }else if(vi == 1 && th == 0 && data.isvivaDone == 0 && settings.module == 2)
                                {
                                    var parms = this.globals.getRandUrl('verify');
                                    this.router.navigateByUrl('/verify/' + parms);
                                }else if(th == 1 && vi == 1 && data.isvivaDone == 1 && settings.module == 3)
                                {
                                    this.globals.vivaexam = 1;
                                    this.globals.theoryexam = 0;
                                    var parms = this.globals.getRandUrl('test-start');
                                    this.router.navigateByUrl('/test-start/' + parms);
                                }
                                else
                                {
                                    this.isErrorLogin = true;
                                    this.errorMsg = 'Invalid Login Code !!';
                                    this.loading = false;   
                                    this.authenticationService.loginstatus(this.globals.root_url, data.usercode, data.std_id)
                                        .pipe(first())
                                        .subscribe(
                                            data => {
                                                if (data.code == 1000) {
                                                    localStorage.removeItem('currentUser_pc');
                                                    sessionStorage.removeItem("pkshn_exam_set_pc");
                                                    sessionStorage.removeItem("pkshn_user_settings_c_s");
                                                }
                                            },
                                            error => {
                                                this.isErrorLogin = true;
                                                this.errorMsg = 'This is incorrect information!!';
                                                this.alertService.error(error);
                                                this.loading = false;
                                                this.spinner.hide();
                                            }
                                        );  

                                }                                                             
                                //this.router.navigate(['verify'], { queryParams: { page: 1 } });
                            }
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = data.status;
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid Login code !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }


    private detectBrowserSuport() {
        let isSupport = true;
        let video = document.createElement('video');
        if (video.canPlayType('video/ogg; codecs="theora"') == "")
            isSupport = false;

        if (video.canPlayType('video/mp4; codecs="avc1.42E01E"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp8, vorbis"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp9"') == "")
            isSupport = false;

        const audio = document.createElement('audio');
        if (audio.canPlayType('audio/mpeg') == "")
            isSupport = false;

        if (audio.canPlayType('audio/wav') == "")
            isSupport = false;

        if (!isSupport) {
            this.alertBrowser.show();
            //alert('Your brawser is unsupported, please update your brawser.');
        }
        else {
            console.log('ok');
        }

    }

}


